import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import "./assets/css/theme.css";
import "./assets/css/layout.css";

// Components
import HomeIndex from "./pages/Home/Index";
import ThankYou from "./pages/Home/ThankYou";
import Navbar from "./Components/Layout/Navbar";
import Footer from "./Components/Layout/Footer";

function AppContent() {
  const location = useLocation();
  const hideNavFooter = location.pathname === "/construction/thankyou";

  return (
    <>
      {!hideNavFooter && <Navbar />}
      <Routes>
        <Route path="/construction/" element={<HomeIndex />} />
        <Route path= "/construction/thankyou" element={<ThankYou />} />
      </Routes>
      {!hideNavFooter && <Footer />}  
    </>
  );
}

function App() {
  return (
    <div className="">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
